interface AppConfig {
  apiBaseUrl: string;
  auth0: {
    domain: string;
    clientId: string;
    audience: string;
  };
  appName: string;
}

const env = import.meta.env;

export const config: AppConfig = {
  apiBaseUrl: env.VITE_API_BASE_URL || "/api",
  auth0: {
    domain: env.VITE_AUTH0_DOMAIN || "",
    clientId: env.VITE_AUTH0_CLIENT_ID || "",
    audience: env.VITE_AUTH0_AUDIENCE || "",
  },
  appName: "Geo Transport Staff Review",
};
